import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  AfterViewInit,
  ɵbypassSanitizationTrustResourceUrl as bypassSanitizationTrustResourceUrl,
  Input, inject
} from '@angular/core';
import { DocsPopService } from './docs-pop.service';
import { combineLatest } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { DialogComponent } from '@zerops/zef/dialog';
import { ThemeService } from '@zerops/zef/theme';

@Component({
  selector: 'zui-docs-pop',
  templateUrl: './docs-pop.component.html',
  styleUrls: [ './docs-pop.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZuiDocsPopComponent implements AfterViewInit {

  #docsPopService = inject(DocsPopService);
  #themeService = inject(ThemeService);

  @ViewChild(DialogComponent)
  dialogRef: DialogComponent;

  @Input()
  documentationPath: string;

  _dialogOpen = false;
  _dialogOptions = {
    hasBackdrop: true,
    width: '940px',
    maxWidth: '92vw'
  };

  docsPath$ = combineLatest([
    this.#docsPopService.getEntity$().pipe(filter((d) => !!d)),
    this.#themeService.isDarkMode$
  ]).pipe(
    map(([ ent, isDarkMode ]) => this.#getPath(ent, isDarkMode))
  );

  ngAfterViewInit() {
    this.#docsPopService.saveRef(this);
  }

  open() {
    this._dialogOpen = true;
  }

  close() {
    this._dialogOpen = false;
  }

  closeTrigger(): void {
    this._dialogOpen = false;
  }

  #getPath(ent: string, isDarkMode: boolean) {
    const [ path, hash ] = ent.split('#');
    const theme = isDarkMode ? 'dark' : 'light';
    const fullPath = `${this.documentationPath}${path}?docusaurus-theme=${theme}${hash ? `#${hash}` : ''}`;

    return bypassSanitizationTrustResourceUrl(fullPath);
  }

}
